import Vue from "vue";
import Vuex from "vuex";

// import the auto exporter
import modules from "@/stores/index.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
});
